import getStore from '../store';
import { DayGridViewState } from '../schema/DayGridStore';

export default function getAllScenarioStores(): DayGridViewState[] {
    return [...getStore().scenarios.values()];
}
